import { Divider, styled } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

const HeaderText = styled("p")({
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
});

const CustomDivider = styled(Divider)(({ theme }) => ({
  marginTop: "16px",
  borderColor: "#cccccc",
}));

const Warranty = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <HeaderText>{t("warrantyHeader")}</HeaderText>
      <CustomDivider />
      <div
        style={{
          marginTop: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <span>
          საგარანტიო მომსახურება გულისხმობს საქართველოს კანონმდებლობის
          საფუძველზე მომხმარებლის უფლებას, ნივთის შეძენიდან 2 (ორი) წლის
          განმავლობაში მოითხოვოს მისი უსასყიდლოდ შეკეთება ან შეცვლა ან
          ხელშეკრულებიდან გასვლა, ფასის შემცირება, თუ საგარანტიო ვადის
          განმავლობაში ნივთი ნაკლის მქონე აღმოჩნდა. თუ საქონელი აღმოჩნდა ნაკლის
          მქონე მომხმარებლის მიერ საქონლის მფლობელობაში მიღებიდან ექვსი თვის
          ვადაში, მაშინ საწინააღმდეგოს დამტკიცებამდე ივარაუდება, რომ ნაკლი
          არსებობდა საქონლის მიწოდებისას, თუ საქონლის ბუნებიდან ან ნაკლის
          ხასიათიდან გამომდინარე ეს შესაძლებელია. ამ შემთხვევაში, მტკიცების
          ტვირთი ეკისრება მოვაჭრეს. თუ მომხმარებელმა საქონლის ნაკლი საქონლის
          მფლობელობაში მიღებიდან ექვსი თვის შემდეგ აღმოაჩინა, იმის მტკიცების
          ტვირთი, რომ ნაკლი არსებობდა საქონლის მიწოდებისას, მომხმარებელს
          ეკისრება.
        </span>
        <span>
          მომხმარებელს უფლება აქვს, "მობაილ სთორს" მოსთხოვოს ნივთის უსასყიდლოდ
          შეკეთება ან შეცვლა, გარდა იმ შემთხვევისა, როდესაც ეს, ნივთის ბუნებიდან
          გამომდინარე, შეუძლებელია ან არათანაზომიერ ან შეუსაბამოდ დიდ ხარჯს
          მოითხოვს.
        </span>

        <span>
          ნივთი შეკეთებული ან შეცვლილი უნდა იქნეს გონივრულ ვადაში, რომელიც არ
          უნდა აღემატებოდეს 15 სამუშაო დღეს. იმ შემთხვევაში, თუ ნივთის
          შეკეთებისათვის საჭიროა სათადარიგო ნაწილის საზღვარგარეთ შეძენა ან
          ნივთის გაგზავნა საზღვარგარეთ მწარმოებლის ავტორიზებულ სერვის ცენტრში,
          მაშინ შეკეთების ვადა შეადგენს 30 სამუშაო დღეს.
        </span>

        <span>
          ნივთის უსასყიდლოდ შეკეთება ან შეცვლა გულისხმობს "მობაილ სთორის" მიერ
          ყველა ხარჯის (მათ შორის, ფოსტის, სამუშაო ძალისა და მასალების ხარჯების)
          გაწევას, რომლებიც საჭიროა ნივთის ხელშეკრულებით გათვალისწინებულ
          პირობებთან შესაბამისობის უზრუნველსაყოფად.
        </span>

        <span>
          მომხმარებელს უფლება აქვს, მოითხოვოს ნივთის ფასის შემცირება ან უარი
          თქვას ხელშეკრულებაზე, თუ არსებობს ერთ-ერთი შემდეგი პირობა: - საქონლის
          შეკეთება ან შეცვლა შეუძლებელია გონივრულ ვადაში; - "მობაილ სთორიმ"
          ნივთი გონივრულ ვადაში არ შეაკეთა ან არ შეცვალა და მომხმარებელმა
          ხელშეკრულების შესრულებისადმი ინტერესი დაკარგა; - "მობაილ სთორის" მიერ
          საქონლის შეკეთება ან შეცვლა მომხმარებელს მნიშვნელოვან შეფერხებას
          შეუქმნის.
        </span>

        <span>
          მომხმარებელს უფლება აქვს, ხელშეკრულებიდან გასვლის შემთხვევაში
          მოითხოვოს ხელშეკრულების შეუსრულებლობით მიყენებული ზიანის ანაზღაურება
          საქართველოს კანონმდებლობით დადგენილი წესით. • მომხმარებელს არ აქვს
          უფლება, უარი თქვას ხელშეკრულებაზე, თუ საქონლის ნაკლი უმნიშვნელოა. •
          იმის განსაზღვრისას, თუ რამდენად არათანაზომიერია ან შეუსაბამოდ დიდია
          ხარჯი, გათვალისწინებული უნდა იქნეს შემდეგი პირობები: ა) ნივთის ან
          მომსახურების ფასი მისი ხელშეკრულებით გათვალისწინებულ პირობებთან
          შესაბამისობის შემთხვევაში; ბ) ნივთის ან მომსახურების ხელშეკრულებით
          გათვალისწინებულ პირობებთან შეუსაბამობის ხარისხი; გ) ნივთის ნაკლის
          მომხმარებლისთვის შეფერხების შექმნის გარეშე აღმოფხვრის ალტერნატიული
          შესაძლებლობა.
        </span>

        <span>
          საგარანტიო მომსახურება არ ხორციელდება|უქმდება, თუ: • გასულია
          საგარანტიო ვადა; • საგარანტიო ბარათი არ არის წარმოდგენილი / დაკარგულია
          და სხვაგვარად ვერ ხდება შეძენის იდენტიფიცირება; • პროდუქტზე მონაცემები
          წაშლილი, შეცვლილი ან გადაკეთებულია; • ნივთზე არ იკითხება / ამძვრალია
          სერიული ნომერი /იმეი კოდი; • დაზიანებულია ან ამძვრალია პლომბი ან ლუქი;
          • მოწყობილობას აღენიშნება ვიზუალური ან მექანიკური დეფექტი / დაზიანება;
          • მოწყობილობა გამოიყენებოდა მისი დანიშნულების შეუსაბამო მიზნით; •
          მოწყობილობა დაშლილია (გახსნილია) თვითნებური შეკეთების ან რაიმე სხვა
          მიზნით; • დაზიანება გამოწვეულია კომპიუტერული ვირუსის ან შეუსაბამო
          ფაილების მიერ; • დაზიანება გამოწვეულია მექანიზმში უცხო სხეულის ან
          სითხეების შეღწევით; • დაზიანება გამოწვეულია ექსპლუატაციის და შენახვის
          წესების და პირობების დარღვევით; • თუ მობილურ ტელეფონზე, პლანშეტზე,
          ფოტოაპარატზე, პროექტორზე, მონიტორზე, ტელევიზორზე ჩამქრალია მწარმოებლის
          მიერ დადგენილი რაოდენობის პიქსელი. მომსახურე სერვის ცენტრი პასუხს არ
          აგებს მოწყობილობაში მომხმარებლის მიერ განთავსებული ინფორმაციის
          შენახვაზე.
        </span>

        <span>
          ამ თავით კომპანიის მიერ განსაზღვრული წესები არ ზღუდავს მომხმარებლის
          უფლებას ისარგებლოს კანონით დადგენილი 2 წლიანი გარანტიის პირობით. ნივთი
          შეიცვლება შემდეგ შემთხვევებში: • თუ ნივთს გახსნისთანავე, ყიდვის
          მომენტში, "მობაილ სთორის" წარმომადგენლის თანდასწრებით დაუფიქსირდა
          ვიზუალური დეფექტი;* • თუ შეძენილ ნივთს შეძენიდან 7 (შვიდი) კალენდარული
          დღის ვადაში აღმოაჩნდა ქარხნული დეფექტი (არ იგულისხმება ვიზუალური
          დაზიანება და პროგრამული ხარვეზი), და მომხმარებლის მიერ აღნიშნულ ვადაში
          ნივთი წარდგენილ იქნა შესაბამის ექსპერტიზაზე რომელიც ადასტურებს ნივთის
          ქარხნულ დეფექტს;
        </span>

        <span>
          ნივთის შეცვლა ხდება იგივე ან მეტი (მომხმარებლის მიერ განსხვავების
          დამატებითი გადახდით) ღირებულების ნივთის გადაცვლით, რომელიც შეცვლის
          მომენტში "მობაილ სთორის" გაყიდვაშია. ნივთის ღირებულება განისაზღვრება
          მომხმარებლის მიერ მისი შეძენისას გადახდილი ფასიდან.
        </span>

        <span>
          მომხმარებლის მიერ ნივთის დისტანციური ხელშეკრულების ან სარეწის გარეთ
          დადებული ხელშეკრულების საფუძველზე შეძენისას, მომხმარებელს უფლება აქვს,
          ყოველგვარი საფუძვლის მითითების გარეშე თქვას უარი დისტანციურ
          ხელშეკრულებაზე ან/და სარეწის გარეთ დადებულ ხელშეკრულებაზე 14
          კალენდარული დღის განმავლობაში. ასეთ შემთხვევაში, მომხმარებელი
          ვალდებულია საკუთარი ხარჯით (ნივთის ტრანსპორტირება, დემონტაჟი და სხვა)
          დაუბრუნოს ნივთი "მობაილ სთორის" თუ ნივთის ღირებულება აღემატება 30
          ლარს.
        </span>

        <span>
          *თუ ნივთი ვიზუალურად არ დათვალიერდა მომხმარებლის მოთხოვნით, კომპანია
          იხსნის პასუხისმგებლობას ნივთის ვიზუალურ დაზიანებაზე;
        </span>

        <span>
          ზოგადი რეკომენდაცია გთხოვთ, დაათვალიეროთ ვიზუალურად თქვენ მიერ
          შეძენილი ნივთი ყიდვის მომენტში რადგან ნივთი, რომელსაც თქვენ იძენთ,
          მომავალში შეიცვლება მხოლოდ თავდაპირველი ნაკლის აღმოჩენის შეთხვევაში.
          გთხოვთ, გაითვალისწინოთ, რომ ელექტრო მოწყობილობის წყალში/სითხეში
          მოთავსება რეკომენდებული არ არის. აღნიშნული გაფრთხილება ეხება იმ
          მოდელებსაც, რომლებზეც მწარმოებელი კომპანია ადასტურებს, რომ არის
          „წყალგამძლე". იმისთვის, რომ მოწყობილობაში წყალი/სითხე არ შევიდეს,
          საჭიროა მწარმოებელი კომპანიის მოთხოვნების ზედმიწევნით დაცვა,
          წინააღმდეგ შემთხვევაში მოწყობილობაში ხვდება სითხე/წყალი. მოწყობილობაში
          წყლის სითხის შეღწევის შემთხვევაში კომპანია იხსნის ვალდებულებას
          მოწყობილობის შემდგომ საგარანტიო მომსახურეობაზე. გთხოვთ, არ დატოვოთ
          საჭიროზე მეტი ხნით თქვენი მოწყობილობა დამტენზე. დამატებითი დამტენი
          ბლოკის შეძენისას დარწმუნდით, რომ ახალი დამტენი ბლოკის ვოლტაჟი
          (V–იგივე) და ამპერაჟი (A-იგივე ან მეტი) ემთხვევა თქვენი ნივთის ვოლტაჟს
          და ამპერაჟს. იმისთვის, რომ თქვენმა მოწყობილობამ იმუშაოს გამართულად,
          გთხოვთ, გამოიყენოთ ლიცენზირებული ოპერაციული სისტემა, საოფისე და სხვა
          პროგრამები. თუ აპირებთ ლეპტოპში მეხსიერების ან ოპერატიული მეხსიერების
          დამატებას/გაზრდას, გთხოვთ, დაუკავშირდეთ მწარმოებლის ავტორიზებულ სერვის
          ცენტრს. მხოლოდ მათი დახმარებით უნდა განხორციელდეს ამა თუ იმ ნაწილის
          შეცვლა თქვენი სურვილისამებრ.
        </span>
      </div>
    </Box>
  );
};

export default Warranty;
